import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { formMappings } from "../../../../config/formMappings";
import { FormEntry } from "../../../../types/types";

interface TotalTableCountProps {
  v2Entries: FormEntry[];
}

export default function TotalTableCount({ v2Entries }: TotalTableCountProps) {
  const activeFormName = useSelector(
    (state: RootState) => state.activeForm.activeFormName
  );
  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const transportationRequestMapping =
    formMapping && "transportationRequest" in formMapping
      ? formMapping.transportationRequest?.fieldMappings
      : undefined;

  // Calculate total number of people who need rides and have paid
  const totalPeople = v2Entries
    .filter((entry) => {
      if (!transportationRequestMapping) return false;

      // Check if entry is paid
      const paidStatusRaw =
        entry.meta[transportationRequestMapping.paid] ||
        entry.meta["Paid?"] ||
        "No";
      const paidStatus = Array.isArray(paidStatusRaw)
        ? paidStatusRaw[0]
        : paidStatusRaw;
      return paidStatus === "Yes";
    })
    .reduce((sum, entry) => {
      if (!transportationRequestMapping) return sum;

      const numberOfPeopleStr =
        entry.meta[transportationRequestMapping.numberOfPeople] || "0";
      const numberOfPeople = parseInt(
        Array.isArray(numberOfPeopleStr)
          ? numberOfPeopleStr[0]
          : numberOfPeopleStr,
        10
      );
      return sum + (isNaN(numberOfPeople) ? 0 : numberOfPeople);
    }, 0);

  return (
    <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
      <dt className="truncate text-sm font-medium text-gray-500">
        People Needing Rides (Paid)
      </dt>
      <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
        {totalPeople}
      </dd>
    </div>
  );
}
